function normalizeAmountRaw(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null;
    return String(value);
  }

  let raw = String(value).trim().replace(/,/g, "");
  if (!raw || raw === "—" || raw === "-") return null;
  raw = raw.replace(/^₹\s?/, "").replace(/\s?\/-$/, "").trim();
  return raw || null;
}

/** Truncate (never round) to exactly 2 decimal places. */
export function truncateAmountParts(value) {
  let raw = normalizeAmountRaw(value);
  if (raw == null) return null;

  let match = raw.match(/^(-?)(\d+)(?:\.(\d*))?$/);
  if (!match) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return null;
    raw = n.toString();
    if (raw.includes("e") || raw.includes("E")) {
      const sign = n < 0 ? "-" : "";
      raw = `${sign}${Math.abs(n).toFixed(12).replace(/\.?0+$/, "")}`;
    }
    match = raw.match(/^(-?)(\d+)(?:\.(\d*))?$/);
    if (!match) return null;
  }

  const [, sign, intPart, fracRaw = ""] = match;
  const fraction = (fracRaw + "00").slice(0, 2);

  return {
    sign: sign === "-" ? "-" : "",
    intPart: intPart || "0",
    fraction,
    numeric: Number(`${sign}${intPart}.${fraction}`),
  };
}

function formatIntPart(intPart) {
  return Number(intPart).toLocaleString("en-IN");
}

/** "1,234.50" without currency symbol */
export function formatAmountNumber(value) {
  const parts = truncateAmountParts(value);
  if (!parts) return "—";
  const { sign, intPart, fraction } = parts;
  return `${sign}${formatIntPart(intPart)}.${fraction}`;
}

/** Format as Indian Rupees. Always shows 2 decimal places (truncated, not rounded). */
export function formatInr(value, { symbolSpace = true } = {}) {
  const parts = truncateAmountParts(value);
  if (!parts) return "—";
  const { sign, intPart, fraction } = parts;
  const amount = `${formatIntPart(intPart)}.${fraction}`;
  if (sign === "-") {
    return symbolSpace ? `-₹ ${amount}` : `-₹${amount}`;
  }
  return symbolSpace ? `₹ ${amount}` : `₹${amount}`;
}

export function formatBalanceRupees(value, { suffix = "", symbolSpace = true } = {}) {
  const parts = truncateAmountParts(value);
  if (!parts) return "—";
  const { sign, intPart, fraction } = parts;
  const amount = `${formatIntPart(intPart)}.${fraction}`;
  const sym = symbolSpace ? "₹ " : "₹";
  if (sign === "-") {
    return symbolSpace ? `-${sym}${amount}${suffix}` : `-₹${amount}${suffix}`;
  }
  return `${sym}${amount}${suffix}`;
}

export function formatSummaryRupees(value) {
  const parts = truncateAmountParts(value);
  if (!parts) return "—";
  const { intPart, fraction } = parts;
  return `₹ ${formatIntPart(intPart)}.${fraction}`;
}

export function formatTripAmount(value) {
  return formatInr(value, { symbolSpace: false });
}

export function formatRupeesAbsolute(value) {
  const parts = truncateAmountParts(value);
  if (!parts) return "—";
  const { intPart, fraction } = parts;
  return `₹ ${formatIntPart(intPart)}.${fraction}`;
}

export function formatLedgerAmount(value) {
  if (value === "-" || value == null || value === "") return "—";
  const parts = truncateAmountParts(value);
  if (!parts) return String(value);
  return formatInr(value);
}
